import { render, staticRenderFns } from "./UnidadesMedicas.vue?vue&type=template&id=7eb6d7f0"
import script from "./UnidadesMedicas.vue?vue&type=script&lang=js"
export * from "./UnidadesMedicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports